/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_EmailInputs */

const he_common_email = /** @type {(inputs: Common_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אימייל`)
};

const en_common_email = /** @type {(inputs: Common_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Common_EmailInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_email = /** @type {((inputs?: Common_EmailInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_EmailInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_email(inputs)
	return en_common_email(inputs)
});